/**
 * Specifies supported locales in the web and exports url slug translations
 */

export const language = {
  ENGLISH: 'en',
  DANISH: 'da',
  DUTCH: 'nl',
  FRENCH: 'fr',
  GERMAN: 'de',
  ITALIAN: 'it',
  NORWEGIAN: 'no',
  RUSSIAN: 'ru',
  SWEDISH: 'sv',
  SPANSISH: 'es',
  PORTUGUESE: 'pt',
}

export const languages = Object.values(language)

export const translatedLanguageNames = {
  en: 'English',
  nl: 'Nederlands',
  sv: 'Svenska',
  fr: 'Français',
  de: 'Deutsch',
  no: 'Norsk',
  ru: 'Русский',
  da: 'Dansk',
  it: 'Italiano',
  es: 'Español',
  pt: 'Português',
}

export const currency = {
  USD: 'USD',
  AUD: 'AUD',
  CHF: 'CHF',
  DKK: 'DKK',
  EUR: 'EUR',
  GBP: 'GBP',
  NOK: 'NOK',
  NZD: 'NZD',
  SEK: 'SEK',
}

export const currencies = Object.values(currency)

export const Slugs = {
  food: {
    en: 'food',
    nl: 'eten',
    sv: 'kost',
    fr: 'aliments',
    de: 'lebensmittel',
    no: 'kost',
    ru: 'food',
    da: 'mad',
    it: 'cibo',
    es: 'comida',
    pt: 'comida',
  },
  features: {
    en: 'features',
    nl: 'functies',
    sv: 'funktioner',
    fr: 'fonctionnalites',
    de: 'funktionen',
    no: 'innehold',
    ru: 'features',
    da: 'funktioner',
    it: 'funzioni',
    es: 'funciones',
    pt: 'funções',
  },
  fitness: {
    en: 'fitness',
    nl: 'fitness',
    sv: 'fitness',
    fr: 'fitness',
    de: 'fitness',
    no: 'fitness',
    ru: 'fitness',
    da: 'fitness',
    it: 'fitness',
    es: 'fitness',
    pt: 'fitness',
  },
  'health-education': {
    en: 'health-education',
    nl: 'gezondheidsopleiding',
    sv: 'halsoutbildning',
    fr: 'educacion-sante',
    de: 'gesundheitserziehung',
    no: 'helse-utdanning',
    ru: 'health-education',
    da: 'sundhedsuddannelse',
    it: 'educazione-alla-salute',
    es: 'educacion-para-la-salud',
    pt: 'educação-em-saúde',
  },
  influencer: {
    en: 'influencer',
    nl: 'influencer',
    sv: 'influencer',
    fr: 'influencer',
    de: 'influencer',
    no: 'influencer',
    ru: 'influencer',
    da: 'influencer',
    it: 'influencer',
    es: 'influencer',
    pt: 'influencer',
  },
  marketing: {
    en: 'marketing',
    nl: 'marketing',
    sv: 'marketing',
    fr: 'marketing',
    de: 'marketing',
    no: 'marketing',
    ru: 'marketing',
    da: 'marketing',
    it: 'marketing',
    es: 'marketing',
    pt: 'marketing',
  },
}
